import { Label } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './styled';
import type { CardProps } from './types';

export const Card: FC<CardProps> = (props) => {
  const { breed, date, person, link, status, onActionsClick } = props;

  const { translate } = useTranslation();

  return (
    <Styled.Wrapper to={link}>
      <Styled.BreederContainer
        data-title={
          person.type === 'buyer' ? translate('glossary.breeder') : translate('glossary.name')
        }
      >
        <Styled.BreederImage src={person.image} alt={breed.title} />
        <Styled.BreederTextContainer>
          <Styled.BreederTitle>{person.title}</Styled.BreederTitle>
        </Styled.BreederTextContainer>
      </Styled.BreederContainer>

      <Styled.PreferencesContainer data-title={translate('glossary.breed')}>
        <Styled.PreferencesTextContainer>
          <Styled.BreedTitle>{breed.title}</Styled.BreedTitle>
        </Styled.PreferencesTextContainer>
      </Styled.PreferencesContainer>
      <Styled.StatusContainer data-title={translate('glossary.status')}>
        <Label {...status} size="small" />
      </Styled.StatusContainer>
      {/* replace the . to avoid extending locales in FR */}
      <Styled.CreatedText>{date.format('DD MMM YY').replace('.', '')}</Styled.CreatedText>
      {onActionsClick && (
        <Styled.ActionsButton
          color="blue"
          size="small"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onActionsClick?.(event);
          }}
        >
          <Styled.ActionsIcon icon="ellipsis-v" />
        </Styled.ActionsButton>
      )}
    </Styled.Wrapper>
  );
};
